angular.module('com.vmware.platform.ui').directive('leftPanel', [function () {
   return {
      restrict: 'E',
      template: '<div class="vui-panel top-level left-panel">' +
         '<object-navigator></object-navigator>' +
         '</div>'
   };
}]);
